import { render, staticRenderFns } from "./BaseBatchUpload.vue?vue&type=template&id=45f76010&scoped=true&"
import script from "./BaseBatchUpload.vue?vue&type=script&lang=js&"
export * from "./BaseBatchUpload.vue?vue&type=script&lang=js&"
import style0 from "./BaseBatchUpload.vue?vue&type=style&index=0&id=45f76010&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f76010",
  null
  
)

export default component.exports